import React, { useEffect } from "react";
import { useTranslation } from 'react-i18next';
import "./home.css";
import Me from "../../assets/profielfoto.jpg";
import HeaderSocials from "./HeaderSocials";
import ScrollDown from "./ScrollDown";
import Shapes from "./Shapes";
import Typing from "./Typing";

const Home = () => {
    const { t } = useTranslation();

    useEffect(() => {
        const shapes = document.querySelectorAll('.shape');
        let timeout;

        const handleMouseMove = (event) => {
            if (timeout) return; // Throttle the mouse move event
            timeout = setTimeout(() => timeout = null, 10);

            shapes.forEach((shape) => {
                const rect = shape.getBoundingClientRect();
                const shapeCenterX = rect.left + rect.width / 2;
                const shapeCenterY = rect.top + rect.height / 2;
                const deltaX = event.clientX - shapeCenterX;
                const deltaY = event.clientY - shapeCenterY;
                const distance = Math.sqrt(deltaX * deltaX + deltaY * deltaY);
                
                if (distance < 100) { // Only affect shapes within 100px radius
                    const angle = Math.atan2(deltaY, deltaX);
                    const pushDistance = (100 - distance) / 2;
                    const moveX = -Math.cos(angle) * pushDistance;
                    const moveY = -Math.sin(angle) * pushDistance;
                    
                    shape.style.transition = 'transform 0.1s ease-out';
                    shape.style.transform = `translate(${moveX}px, ${moveY}px)`;
                }
            });
        };

        const resetShapes = () => {
            shapes.forEach(shape => {
                shape.style.transition = 'transform 0.8s cubic-bezier(0.4, 0, 0.2, 1)';
                shape.style.transform = 'translate(0, 0)';
            });
        };

        document.addEventListener('mousemove', handleMouseMove);
        document.addEventListener('mouseleave', resetShapes);

        return () => {
            document.removeEventListener('mousemove', handleMouseMove);
            document.removeEventListener('mouseleave', resetShapes);
        };
    }, []);

    return (
        <section className="home" id="home">
            <div className="container">
                <div className="intro">
                    <img src={Me} alt="Profielfoto" className="home__img" />
                    <h1 className="home__name">Bram Platier</h1>
                    <div className="home__greeting">
                        <Typing />
                    </div>
                    <div className="home__greeting-static">
                        {t('hello')}
                    </div>
                
                    <HeaderSocials/>

                    <a href="#contact" className="btn">{t('contact_me')}</a>
                    
                    <ScrollDown/>
                </div>
            </div>
            <Shapes />
        </section>
    );
};

export default Home;